module.exports = __webpack_public_path__ + "img/slick-slider-nav-next.5820c059.svg";